// imports
import { FC } from 'react';

//components
import { AuthLayout } from 'components/common/AuthLayout';
import { ENTER_DETAIL_TEXT, SIGN_UP_TEXT } from 'constants/index';
import { SignupForm as SignupComponent } from 'components/Auth/Signup';

const Signup: FC = () => (
  <AuthLayout title={SIGN_UP_TEXT} subTitle={ENTER_DETAIL_TEXT}>
    <SignupComponent />
  </AuthLayout>
);

export default Signup;
